// extracted by mini-css-extract-plugin
export default {"label":"label---SgZpf","error":"error---um2EY"};